// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Resource from 'vue-resource'
import VueRouter from 'vue-router'
import Toasted from 'vue-toasted'
import VueCookies from 'vue-cookies'
import Plugins from './lib/plugin.js'
import AppView from './App.vue'
import routes from './routes'
import VeeValidate from 'vee-validate'
import VueI18n from 'vue-i18n'

Vue.config.productionTip = false
/* Resource logic */
Vue.use(Resource)
Vue.use(Toasted)
Vue.use(routes)
Vue.use(VueCookies)
Vue.use(VeeValidate)
Vue.use(Plugins)
Vue.use(VueI18n)

//  Locales
import french from './components/resources/locales/fr.json'
import english from './components/resources/locales/en.json'
let locale = 'fr'// navigator.language

var messages = {
  en: english,
  fr: french
  // more languages
}

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'fr',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true
})

Vue.prototype.$locale = {
  change (lang) {
    i18n.locale = lang
  },
  current () {
    return i18n.locale
  }
}

export default i18n

// Set resource root
// Vue.http.options.root = 'https://api.mailgun.net/v3/mg.chaperon.me'

// Vue.http.headers.common['api'] = process.env.MAILGUN_API_KEY
// var key = btoa('api:' + process.env.MAILGUN_API_KEY)

Vue.http.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
// Vue.http.headers.common['Authorization'] = 'Basic ' + window.btoa('api:key-4160a9cb8186327879f4dd0c52a18154')
// Vue.http.headers.common['Authorization'] = 'Basic api:' + process.env.MAILGUN_API_KEY
// Vue.http.headers.common['Authorization'] = 'Basic ' + key
Vue.http.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS'

// Interceptors
Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (request.after) {
      request.after.call(this.response)
    }
  })
})

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // specify offset of the element
      if (to.hash === '#anchor2') {
        position.offset = { y: 100 }
      }
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

// Router
var router = new VueRouter({
  mode: 'history',
  base: __dirname,
  scrollBehavior,
  routes: routes
})

/* eslint-disable no-new */
new Vue({
  el: '#root',
  router,
  i18n: i18n,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js